import { render, staticRenderFns } from "./perfekt-sein-som-hjalpverb.vue?vue&type=template&id=cb491bda&scoped=true"
import script from "./perfekt-sein-som-hjalpverb.vue?vue&type=script&lang=js"
export * from "./perfekt-sein-som-hjalpverb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb491bda",
  null
  
)

export default component.exports